/* eslint-disable react/display-name */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from "next/link";
import { forwardRef } from "react";
import PAImage from "./images/PAImage";
import styles from "./manufactureItem.module.scss";

const ManufactureItem = forwardRef((props: any, ref: any) => {
  const { manufacturer, manufacturerImageLogoUrl } = props;
  return (
    (
      <Link
        href={props.url}
        className={`col-sm-6 col-md-4 col-lg-3 ${styles.manufacture_item_anchor}`}
        onClick={props.onClick}
        ref={ref}
      >

        <div className={`${styles.panel} panel-default`}>

          <div className={styles.panel_heading}>{manufacturer}</div>

          <div className={styles.panel_body}>

            <PAImage
              src={manufacturerImageLogoUrl}
              alt={manufacturer}
              width={310}
              height={150}
            />
          </div>
        </div>

      </Link>
    )
  );
});

export default ManufactureItem;
